<div class="container-fluid vh-100 overflow-auto">
    <!-- Header -->
    <div class="mb-4">
        <p class="ms-3 fw-bold text-x mb-1">Select Verification Service</p>
    </div>

    <!-- Loading State -->
    <div v-if="loading" class="text-center p-4">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2 text-muted">Loading verification services...</p>
    </div>

    <!-- Error State -->
    <div v-else-if="error" class="alert alert-danger mx-2" role="alert">
        {{ error }}
        <button @click="fetch_verification_services" class="btn btn-sm btn-outline-danger ms-2">
            Retry
        </button>
    </div>

    <!-- Verification Service List -->
    <div v-else class="d-flex flex-column gap-3 p-2">
        <!-- Empty state -->
        <div v-if="verification_services.length === 0" class="text-center py-5 text-muted">
            <i class="bi bi-inbox fs-1 mb-2 opacity-50"></i>
            <p class="text-xs mb-0">
                No verification services assigned to this entity.
            </p>
        </div>
        <div
        v-for="(service, index) in verification_services"
        :key="index"
        class="card shadow rounded-lg service-card"
        :class="{
            'border-success-custom bg-light': selected_services.includes(service.id),
            'border-light': !selected_services.includes(service.id),
        }"
        >
        <div class="card-body">
            <!-- Service Header - Clickable area -->
            <div class="d-flex justify-content-between align-items-start mb-2" @click="toggle_service(service.id)">
                <div class="d-flex align-items-center">
                    <!-- Checkbox next to Service Name -->
                    <input
                    type="checkbox"
                    class="form-check-input custom-checkbox me-2 mb-2"
                    :checked="selected_services.includes(service.id)"
                    @click.stop="toggle_service(service.id)"
                    />
                    <div>
                    <p class="fw-bold mb-1 text-xs d-inline">{{ service.name }}</p>
                    <p class="text-muted text-xxs mb-0">{{ service.description }}</p>
                    </div>
                </div>
                <div class="text-end">
                    <span class="fw-bold text-dark">{{ (service.price ?? 0).toLocaleString('en-ZA', { style: 'currency', currency: 'ZAR' }) }}</span>
                </div>
            </div>

            <!-- Field Mapping Section -->
            <div v-if="selected_services.includes(service.id)" class="mt-3 ms-4">
                <p class="fw-bold text-xxs mb-2">Map Required Fields to Questions</p>
                
                <!-- Loading state for questions -->
                <div v-if="loading_questions[service.id]" class="text-center py-2">
                    <div class="spinner-border spinner-border-sm text-primary" role="status">
                        <span class="visually-hidden">Loading questions...</span>
                    </div>
                    <p class="text-muted text-xxs mt-1">Loading questions...</p>
                </div>

                <!-- Questions loaded successfully -->
                <div v-else-if="questions[service.id] && questions[service.id].length > 0">
                    <div
                        v-for="(field, fIndex) in service.combined_fields"
                        :key="fIndex"
                        class="row g-2 align-items-center mb-1"
                    >
                        <div class="col-12 col-md-3">
                            <div
                                class="form-control text-center text-xxs form-control-sm fw-normal rounded-lg"
                            >
                               {{ format_field_name(field.name) }}
                            </div>
                        </div>

                        <div class="col-auto text-center fs-5">→</div>

                        <div class="col-12 col-md-6">
                            <select
                                v-model="mappings[service.id][field.name]"
                                class="form-select form-select-sm text-xxs rounded-lg"
                                @change="update_mapping(service.id, field)"
                                @click.stop="" 
                            >
                                <option disabled value="">Select a question</option>
                                <option
                                    v-for="question in questions[service.id]"
                                    :key="question.id"
                                    :value="question.id"
                                >
                                    {{ question.question_name }}
                                    <span v-if="mappings[service.id] && mappings[service.id][field.name] == question.id"> ✓</span>
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="mt-3 pt-3 border-top d-flex justify-content-end">
                        <button
                            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                            @click.stop="save_single_service(service.id)"
                            :disabled="saving_services[service.id]"
                        >
                            <span v-if="saving_services[service.id]" class="spinner-border spinner-border-sm me-1"></span>
                            {{ saving_services[service.id] ? 'Saving...' : saved_services[service.id] ? 'Update Configuration' : 'Save Configuration' }}
                        </button>
                    </div>
                </div>

                <!-- Still loading or no questions available -->
                <div v-else-if="loading_questions[service.id] === false" class="alert alert-warning text-xxs py-2">
                    No questions available for mapping.
                </div>
            </div>
            
            <!-- Show saved status when collapsed -->
            <div v-else-if="has_saved_mappings(service.id) && !selected_services.includes(service.id)" class="mt-2 ms-4 text-muted text-xxs">
                <i class="fas fa-check-circle text-success me-1"></i>
                This service has saved configurations. Click to view/edit.
            </div>
        </div>
        </div>
    </div>
</div>